import React from 'react';
import { env } from '@zopauk/nextjs-env';
import { useSession, logout, login } from '@zopauk/nextjs-auth';
import { useQueryMember } from '@/utils/queries/useQueryMember';
import { Navbar as ZopaNavbar } from '@zopauk/react-components';
import type { NavbarProps } from '@zopauk/react-components/types/components/organisms/Navbar/Navbar/Navbar';

export interface NavbarStateProps extends NavbarProps {
  routes: Record<'userProfile', string>;
}

export const Navbar = ({ routes, links, ...rest }: NavbarStateProps) => {
  const { data } = useQueryMember();
  const { data: session } = useSession();

  const navItems = session
    ? [
        ...(links || []),
        {
          children: [
            { href: routes.userProfile, label: 'My Details' },
            {
              onClick: logout,
              label: 'Logout',
            },
          ],
          label: data?.data.firstName,
        },
      ]
    : links;

  return (
    // display: contents keeps the wrapper out of layout while still applying the
    // Amplitude mask to the member's first name rendered as a nav item label.
    <div data-amp-mask style={{ display: 'contents' }}>
      <ZopaNavbar
        withCTA={!session}
        links={navItems}
        {...rest}
        cta={
          !session ? (
            <ZopaNavbar.Action
              onClick={async () => {
                await login({ callbackUrl: `${env('NEXT_PUBLIC_APP_URL')}/` });
              }}
              data-automation="ZA.navbar-signin"
            >
              Sign in
            </ZopaNavbar.Action>
          ) : null
        }
      />
    </div>
  );
};
